export default __webpack_public_path__ + "static/media/registrationPackage.e4ebf70f.zip";